import { useLocation } from "react-router-dom";
import style from "./style.module.scss";
import arrowImg from "../Arrow.png";
import { useState } from "react";
import { SignupSubmit } from "../../../../../Web/View/Auth/Components/Services";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

const SignUp = ({ setStep, setShowModal }) => {
    let location = useLocation();

    const { mobile } = useSelector(state => state);

    let initialState = {
        fullname: null,
        mobile: location.state ? location.state.mobile : mobile,
        password: null,
        inviteCode: null
    }
    const [state, setState] = useState(initialState);
    const SginUpHandel = (fullname, password, mobile, inviteCode) => {
        if (!fullname || !password || !mobile) {
            toast.error("لطفا ابتدا فرم را کامل کنید");
        }
        else {
            SignupSubmit(fullname, mobile, inviteCode, password).then(result => {
                setState({ ...state, result: result })
                if (result && result[0] === "Success") {
                    setStep("step5")
                }
                else {
                    toast.error("مشکلی پیش آمده");
                }
            })
        }
    }
    return (
        <>
            <section>
                <div>
                    <img src={arrowImg} onClick={() => setStep("step2")} className={style.arrowIcon} alt="arrowIcon" />
                    <h3 className={style.titelTextLogin}>ورود / ثبت نام</h3>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="">
                        <p className={style.warnLogin}>لطفا برای ادامه شماره موبایل خود را وارد کنید.</p>
                        <div className={style.parentInputLogin}>
                            <p className="mb-2 mt-3" style={{ color: "#404040", fontWeight: "600" }}>
                                نام و نام خانوادگی خود را وارد نمایید
                            </p>
                            <input className={style.inputLogin} type="text" name="name" value={state && state.fullname || ""} onChange={(e) => setState({ ...state, fullname: e.target.value })} placeholder="نام و نام خانوادگی" id="name" />
                        </div>
                        <div className={style.parentInputLogin}>
                            <p className="mb-2" style={{ color: "#404040", fontWeight: "600" }}>
                                شماره موبایل خود را وارد نمایید
                            </p>
                            <input className={style.inputLogin} type="number" name="number" value={location.state ? location.state.mobile : mobile} onChange={(e) => setState({ ...state, mobile: e.target.value })} placeholder="شماره موبایل" id="number" />
                        </div>
                        <div className={style.parentInputLogin}>
                            <p className="mb-2" style={{ color: "#404040", fontWeight: "600" }}>
                                رمز عبور را وارد کنید
                            </p>
                            <input className={style.inputLogin} type="password" name="password" value={state && state.password || ""} onChange={(e) => setState({ ...state, password: e.target.value })} placeholder="رمز عبور" id="password" />
                        </div>
                        <div className={style.parentInputLogin}>
                            <p className="mb-2" style={{ color: "#404040", fontWeight: "600" }}>
                                کد دعوت را وارد کنید (اختیاری)
                            </p>
                            <input className={style.inputLogin} type="text" name="code" value={state.inviteCode || ""} onChange={(e) => setState({ ...state, inviteCode: e.target.value })} placeholder="به عنوان مثال : niko-224" id="code" />
                        </div>
                        <button className={style.btnLogin} onClick={() => SginUpHandel(state && state.fullname, state && state.password, state && state.mobile, state && state.inviteCode)}>ثبت نام</button>
                        <p className={style.endText}>
                            <span onClick={e => setShowModal(true)} className={"textMain mx-1 diflex"}>قوانین سایت</span>
                            و
                            <span onClick={e => setShowModal(true)} className={"textMain mx-1 diflex"}>حریم خصوصی</span>
                            را می پذیرم
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SignUp;